import { createContext, memo, useRef, useContext } from "react";

export const ColContext = createContext({});

export default memo(({ children }) => {
  const shareRefs = useRef({
  });
  const colContextData = {
    colShareRefs: shareRefs.current,
  };
  
  return (
    <ColContext.Provider value={colContextData}>{children}</ColContext.Provider>
  );
});

export const useColContext = () => {
  return useContext(ColContext);
}
